import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { selectMetadataKeyByRegion } from 'reducers/selectors/metadata';
import { isHomeuser } from 'utils/isHomeuser';

export const useLiveEventCarouselUpdate = () => {
  const keyByRegion = useSelector(
    selectMetadataKeyByRegion('live_event_carousel_update'),
  );
  const location = useLocation();
  const [shouldUpdate, setShouldUpdate] = useState(false);

  const isInHomeuser = isHomeuser(location);
  const { seconds } = keyByRegion || {};

  useEffect(
    () => {
      if (!isInHomeuser || !seconds) {
        setShouldUpdate(false); // Reset si no cumple condiciones
        return;
      }

      const intervalId = setInterval(() => {
        setShouldUpdate(true);

        // Reset to avoid updates in same render
        const timeoutId = setTimeout(() => setShouldUpdate(false), 100);

        return () => clearTimeout(timeoutId);
      }, seconds * 1000);

      return () => clearInterval(intervalId);
    },
    [isInHomeuser, seconds],
  );

  return {
    shouldUpdate: isInHomeuser && !!seconds ? shouldUpdate : false,
  };
};
